<div class="video-play-wrapper" [ngStyle]="{'display': _show ? 'block' : 'none'}" (click)="close()">
  <video 
      id="fullscreen-video" 
      name="media" 
      [poster]="poster" preload="auto"
      playsinline="true" webkit-playsinline="true" x5-video-player-type="h5-page" >
      <source type="video/mp4" [src]="src" >
      <p>你的浏览器不支持 <code>Video</code> </p>
  </video>
</div>